<template>
  <ul class="tabs">
    <li
      v-on:click="change('gal')"
      v-bind:class="{ active: isActive === 'gal' }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="長方形_36"
              data-name="長方形 36"
              width="18"
              height="18"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
        <g id="グループ_28" data-name="グループ 28" transform="translate(-0.5)">
          <g
            id="グループ_27"
            data-name="グループ 27"
            clip-path="url(#clip-path)"
          >
            <path
              id="パス_54"
              data-name="パス 54"
              d="M84.523,99.43H99.43V84.523H84.523Zm4.75-11.411a1.517,1.517,0,1,1-1.517,1.517,1.517,1.517,0,0,1,1.517-1.517m8.48,7.758a.3.3,0,0,1-.263.158H86.463a.3.3,0,0,1-.25-.463l1.929-2.939a.748.748,0,0,1,1.186-.084l1.33,1.508,2.41-3.668a.748.748,0,0,1,1.249,0L97.74,95.47a.3.3,0,0,1,.014.307"
              transform="translate(-81.266 -81.576)"
            />
            <path
              id="パス_55"
              data-name="パス 55"
              d="M15.711,0H0V15.711H1.608V1.608h14.1Z"
              transform="translate(0.31)"
            />
          </g>
        </g>
      </svg>
      ギャラリー
    </li>
    <li
      v-if="$alllist[Tablocate][Tabid].vrimg"
      v-on:click="change('vr')"
      v-bind:class="{ active: isActive === 'vr' }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <g id="グループ_29" data-name="グループ 29" transform="translate(0 0)">
          <path
            id="合体_1"
            data-name="合体 1"
            d="M3.288,13.848h0c1.533,0,4.236-1.157,6.819-3.741A14.114,14.114,0,0,0,13.56,4.86c.426-1.31.33-2.183.046-2.466a1.39,1.39,0,0,0-.895-.242c-1.532,0-4.235,1.157-6.819,3.741A14.108,14.108,0,0,0,2.44,11.139c-.426,1.31-.33,2.183-.046,2.467a1.39,1.39,0,0,0,.895.242m0,2.151a3.3,3.3,0,0,1-2.416-.872c-2-2-.438-6.82,3.5-10.756s8.752-5.5,10.756-3.5.438,6.819-3.5,10.756C8.855,14.4,5.644,16,3.288,16Z"
            transform="translate(0 0)"
          />
          <path
            id="合体_2"
            data-name="合体 2"
            d="M3.288,13.848h0c1.533,0,4.236-1.157,6.819-3.741A14.114,14.114,0,0,0,13.56,4.86c.426-1.31.33-2.183.046-2.466a1.39,1.39,0,0,0-.895-.242c-1.532,0-4.235,1.157-6.819,3.741A14.108,14.108,0,0,0,2.44,11.139c-.426,1.31-.33,2.183-.046,2.467a1.39,1.39,0,0,0,.895.242m0,2.151a3.3,3.3,0,0,1-2.416-.872c-2-2-.438-6.82,3.5-10.756s8.752-5.5,10.756-3.5.438,6.819-3.5,10.756C8.855,14.4,5.644,16,3.288,16Z"
            transform="translate(16) rotate(90)"
          />
        </g>
      </svg>
      360°ビュー
    </li>
    <li
      v-on:click="change('data')"
      v-bind:class="{ active: isActive === 'data' }"
    >
      <svg
        id="info"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path
          id="楕円形_2"
          data-name="楕円形 2"
          d="M9,1.8A7.2,7.2,0,1,0,16.2,9,7.208,7.208,0,0,0,9,1.8M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
        />
        <rect
          id="長方形_47"
          data-name="長方形 47"
          width="2"
          height="2"
          transform="translate(8 4.444)"
        />
        <rect
          id="長方形_48"
          data-name="長方形 48"
          width="2"
          height="7"
          transform="translate(8 6.769)"
        />
      </svg>
      物件詳細
    </li>
  </ul>
  <div class="contents">
    <div class="gal" v-if="isActive === 'gal'">
      <TabGallery :id="Tabid" :locate="Tablocate" type="thumbnail" />
    </div>

    <div class="vr" v-else-if="isActive === 'vr'">
      <TabGallery :id="Tabid" :locate="Tablocate" type="vrimg" />
    </div>
    <div class="detail" v-else-if="isActive === 'data'">
      <p class="equip">{{ $alllist[Tablocate][Tabid].equip }}</p>
      <p>{{ $alllist[Tablocate][Tabid].detail }}</p>
    </div>
  </div>
</template>

<script>
import TabGallery from "@/components/CpProductTabGal.vue";
export default {
  data() {
    return {
      isActive: "gal",
    };
  },
  components: {
    TabGallery,
  },
  props: ["Tabid", "Tablocate"],
  methods: {
    change: function (num) {
      this.isActive = num;
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  width: 100%;
  overflow: hidden;
  margin-top: 2rem;
  display: grid;
  gap: 2px;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid $color_lgray;
  @include sp {
    grid-template-columns: repeat(3, 1fr);
  }
  li {
    border-radius: 0.5rem 0.5rem 0 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: $color_lgray;
    height: 3rem;
    line-height: 1rem;
    text-align: center;
    cursor: pointer;
    padding-top: 0.2rem;

    @include sp {
      font-size: 0.9rem;
    }
    svg {
      position: relative;
      top: -2px;
      margin-right: 0.5rem;
      fill: $fontcolor;
    }

    &.active {
      background: white;
      color: $color_blue;
      border-bottom: 4px solid $color_blue;
      position: relative;
      svg {
        fill: $color_blue;
      }
    }
  }
}
.contents {
  padding: 1rem 0;
  z-index: 1;

  p {
    font-size: 0.8rem;
    line-height: 2;
  }
  .equip {
    padding-bottom: 0.5em;
    border-bottom: 1px solid $color_lgray;
    margin-bottom: 0.5em;
    &::before {
      content: "主な設備";
      display: inline-block;
      background-color: $color_lblue;
      color: $color_blue;
      padding: 0 0.5em;
      margin-right: 0.5em;
      border-radius: 0.25em;
    }
  }
}
</style>
